import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import { CompetitionSubtitle, ModalContainer} from './styles';
import {useTranslation} from "react-i18next";
import {
  CompetitionModalGS,
  SendProjectModalWrapper
} from "./employStyles";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import { API, APIResponse, Competition, CompetitionAPI, Endpoints, PageModel, Project } from "@brg/api";
import {useProfile} from "../../../core/hooks/auth/useProfile";
import {SortingTypeIndex} from "../../constants/sortingType";
import {LayoutConst, useModal} from "../../../core";
import {SendProjectsEntity} from "./SendProjectsEntity";
import { MagicBoxRow } from "shared/components/MagicBoxRow";
import { RingPositions } from "shared/constants/ringPositionType";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompetitionProjects, getListProps } from "shared/actions/competition";
import { RefreshListProps } from "_competition/pages/AllCompetitionsPage/AllCompetitionsPage";
import { STATUSES } from "_competition/const";
import { useCompetitionContexts } from "shared/hooks/useCompetitionContexts";
import { CompetitionsSelector } from "shared/reducers/Competitions";
import { CompetitionContainer } from "_competition/pages/AllCompetitionsPage/styled";
import { CompetitionCard } from "_competition/pages/AllCompetitionsPage/CompetitionCard";
import { AppTester } from "supporting";
import { ThemeProvider, useTheme } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";
import { SlideNavigation } from "shared/components/slideNavigation";
import { DropdownTabs } from "shared/pages/exploreHseContextsNew/components/DropdownTabs";
import { CreateLinkTo } from "shared/constants/linkTo";
import { DOCUMENT_VARIANT, getDocumentVariant } from "../competitionLegalsModal/types";

const PAGE_LIMIT = 100;

export const SendProjectToCompetition: FC<{project: Project, onCompleteSend?: () => void}> = ({project, onCompleteSend = () => {}}) => {
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s-1);
    const { t, i18n } = useTranslation();
    const theme1 = useTheme();
    const modal = useModal();
    const { theme } = createThemeByColor(theme1.competition.bg, theme1);
    const [time, setT] = useState(new Date().getTime());
    const profile = useProfile();
    const dispatch = useDispatch();
    const { data: competitionList } = useSelector(CompetitionsSelector);
    const [isSendingCompleted, setIsSendingCompleted] = useState(false);
    const [isTabChanged, setIsTabChanged] = useState(false);
    const [pageNumber] = useState(0);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const tabs = useCompetitionContexts();

    const navItems = useMemo(() => (
      {...tabs?.reduce((a, v) => ({ ...a, [v]: t(`tab_names.competition_tabs.${v}`).toLowerCase()}), {})}
    ), [tabs, t])

    const initialTab = useMemo(() => (
      Object.keys(navItems)?.find((item, idx) => idx === 0) ), [navItems])

    const [currentTab, setCurrentTab] = useState<string | undefined>(undefined);
    const [sorting, setSorting] = useState<any>(STATUSES.Open);

    const activeCurrentTab = currentTab ?? initialTab;

    const isAcademy = AppTester.isAcademy();

    const activeTab = useMemo(() => activeCurrentTab, [activeCurrentTab])

    const filterCurrentCompetitions = useCallback((item: APIResponse<PageModel<Competition<"Local">>>) => {
        return [STATUSES.Open].includes(item?.status)
      }, [])

    const fetchList = (props: RefreshListProps) => {
        const { pageNumber, i18n, selectedStatus, dispatch, contexts } = props
        const fetchListProps: getListProps = { initTags: true, limit: PAGE_LIMIT, page: pageNumber, i18n, contexts, initWinner: true, isBriefCompetition: false }
        if (selectedStatus?.identifier !== undefined && selectedStatus?.identifier !== STATUSES.Summarizing) {
          fetchListProps.competitionStatus = [selectedStatus?.identifier]
        }
        dispatch(fetchCompetitionProjects(fetchListProps))
      }

    const fetchProjects = (tab: string) => {
        fetchList({pageNumber, i18n, dispatch, selectedStatus: undefined, contexts: [tab] });
    }

    const onTabChange = useCallback((tab: string) => {
      setCurrentTab(tab);
    }, [])

    const onSelect = useCallback((id: string) => {
        const idx = selectedIds?.findIndex((i) => i === id);
        if (idx !== -1) {
            setSelectedIds(selectedIds?.filter((i) => i !== id));
        } else {
            setSelectedIds([...selectedIds, id])
        }
        setT(Date.now()) 
    }, [selectedIds])

    const isSelected = useCallback((id: string) => selectedIds?.includes(id) , [selectedIds])
//@ts-ignore
    const isPart = useCallback((id: string) => project?.competitionId?.includes(id) || project?.pendingCompetitionIds?.includes(id), [project])

      const filteredCompetitionList = useMemo(() => {
        const filteredCompetitionList = competitionList?.length ? competitionList?.filter((competition: any) => {
          return ![STATUSES.Deleted, STATUSES.Draft].includes(competition.status) && (competition.visibility || competition.visibility === null || competition.visibility === undefined)
        }).filter((i) => filterCurrentCompetitions(i)) : []
    
        if (!filteredCompetitionList?.length) {
          if (activeCurrentTab === "competitions" && isTabChanged) {
            setIsTabChanged(false)
          }
          return []
        }
    
        return filteredCompetitionList
      }, [competitionList, sorting, isMobile, activeCurrentTab, time])

      const getGroupedCompetitions = (competitions: any[]): {isNewType: boolean, items: Competition<'Local'>[]}[] => {
        const result: {isNewType: boolean, items: Competition<'Local'>[]}[] = [];
        var currentGroup: Competition<'Local'>[] = [];
        var isNewType = !!competitions?.[0]?.isNewType;
        competitions.map((x: any) => {
          if (isNewType === x.isNewType) {
            currentGroup.push(x);
          }
          else {
            if (currentGroup.length !== 0) {
              result.push({
                isNewType,
                items: currentGroup
              });
            }
            currentGroup = [];
            currentGroup.push(x);
            isNewType = !isNewType;
          }
        });
    
        if (currentGroup.length !== 0) {
          result.push({
            isNewType,
            items: currentGroup
          });
          currentGroup = [];
        }
        return result
      };

      const competitions = useMemo(() => {
          return (
            getGroupedCompetitions(filteredCompetitionList)
            .map(x => {
              if (x.isNewType) {
                return (
                  <CompetitionContainer>
                    {x.items
                    .map((item, idx, arr) => {
                      const projectsOrder = [
                      'e1f20bda47bb40dd94f4360873cc0871', 
                      'fba8ef7dd7a643269997a9ecbad02ed0',
                      '0dc30b10959847a99aa575d98e6e28b0', 
                      '74d96d672033451a9028a4f1ff12e0b6', 
                      '1c891534c43b4a2abf8868ac03250381',
                      '4585d3c8c68648efa18e4b9d511834d6',
                      'b401549c47f640b29855f2e4068da7c1'
                      ];
    
                      if (isAcademy && activeCurrentTab === 'genius') {
                        return arr?.find((i) => i?.competitionId === projectsOrder[idx])
                      }
                      return item
                    })
                    .map((competitionProps, index, srcArray) => {
                        const selected = isSelected(competitionProps?.competitionId ?? '');
                        const already = isPart(competitionProps?.competitionId ?? '');
                      return (
                        <CompetitionCard
                          key={competitionProps?.competitionId}
                          isNewType={x?.isNewType}
                          competitionProps={competitionProps}
                          isModalCard
                          selectRingPosition={RingPositions.left}
                          onSelect={onSelect}
                          isSelected={selected}
                          isAlready={already}
                        />
                      )
                    }
                    )}
                  </CompetitionContainer>
                );
              }
            })
          )
      }, [activeCurrentTab, filteredCompetitionList, isAcademy, onSelect, isSelected, isPart]);

    useEffect(() => {
        fetchProjects(activeTab)
    }, [time, activeTab])
    
    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
      setSorting(s);
      setT(Date.now());
    }, []);

    const onMobileSortingClick = useCallback(() => {
      setSorting((prev: any) => prev === 1 ? 2 : 1);
    }, []);


    const onSendSimpleNomination = useCallback(async (arr: string[]) => {
      await Promise.all(arr.map(value => {      
        CompetitionAPI.Get({ idCompetition: value, initWinner: true })
        .then((v) => v.json())
        .then((v) => API.toLang<Competition<'Local'>>(v, i18n.language))
        .then((v) => {
          if (v) {
            API.request()
            .endpoint(Endpoints.competitions)
            .url('/api/Competition/Apply')
            .post()
            .addQuery('NominationID', v?.nominationsID?.length ? v.nominationsID[0] : '')
            .addQuery('ProjectID', project?.projectId)
            .send()
          }
        });
      })
    );

    modal.show('competition-sent', {
      competitionId: '',
      someNominations: arr?.length > 1,
      isShareModal: true,
      onClick: () => {
        window.open(CreateLinkTo.explore(), '_SELF')
      },
    });
  }, [i18n,modal, project]) 

    const onSend = useCallback(async () => {

        const res = window.confirm(t('competition.confirm_msg.send'));
        if (!res) return;

          try {
            await CompetitionAPI.GetList({ competitionIds: selectedIds })
            .then((v) => v.json())
            .then((r) => {
              const data = r?.data?.map((i) => API.toLang<Competition<'Local'>>(i, i18n.language));

              if (data?.length) {
                const shouldViewLegalsModal = data?.some((c) => [DOCUMENT_VARIANT.full, DOCUMENT_VARIANT.short]?.includes(getDocumentVariant(c)));

                if (shouldViewLegalsModal) {
                  const nominationsIds = data?.map((c) => c?.nominationsID?.[0]);
                  const hasDocuments = data?.some((c) => [DOCUMENT_VARIANT.full]?.includes(getDocumentVariant(c)));
                  modal.show('competition-form', {
                    projects: [project?.projectId],
                    nominationIds: nominationsIds,
                    // @ts-ignore
                    competitionId: competitions?.competitionId,
                    hasDocuments,
                    callback: () => {
                      modal.hide();

                      setTimeout(() => {
                        modal.show('competition-sent', {
                          competitionId: '',
                          someNominations: selectedIds?.length > 1,
                          isShareModal: true,
                          onClick: () => {
                            window.open(CreateLinkTo.explore(), '_SELF')
                          },
                      });
                      })
                    },
                  })
                } 
                else onSendSimpleNomination(selectedIds)
              }
            })

            setSelectedIds([]);
            setT(Date.now());
          
          } catch (e) {
            return new Error(String(e))
          }
    }, [selectedIds, project, i18n.language, t, modal, onSendSimpleNomination])

    const title = useMemo(() => <CompetitionSubtitle>{t('sharing.part_subtitle_text')}</CompetitionSubtitle>, [t])

    const tabsComponent = useMemo(() => {
      return (
        <FlexBox offsetTopMobile={isS ? 8 : 0}>
          {!isMobile ? (
            <SlideNavigation
              activeIndexKey={activeTab}
              onChange={onTabChange}
              items={navItems}
              isDropdown
              autoWidth
              isLoading={false}
              whiteTheme={false}
              isCompetition={true}
            /> 
          ) : (
           <>
              <DropdownTabs
                customTitleTheme={theme as any}
                whiteTheme={false}
                activeTabKey={activeTab}
                isShort={true}
                items={navItems}
                onChange={onTabChange}
              />
           </>
          )}
        </FlexBox>
      )
    }, [activeTab, navItems, theme, isMobile, onTabChange ])

    if (!profile) {
        return null;
    }


    return <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
        <SendProjectModalWrapper width={'100%'} directionMobile='column' direction='column' justify={'flex-start'} align={"center"} alignMobile="flex-start" style={{ position: 'relative'}}>
            <ThemeProvider theme={theme as any}>
              <CompetitionModalGS />
            <SendProjectsEntity
              isCompetitionModal 
              noProjectCheckbox={title}
              tabs={tabsComponent} 
              noProjectVisible
              hideFilter
              count={selectedIds?.length || 0}
              isDisabledSendButton={!selectedIds?.length} 
              onMobileSortingClick={onMobileSortingClick} 
              onSortingChange={onSortingChange} 
              sorting={sorting} 
              onSend={onSend} 
              isClosed={!(!isSendingCompleted)}
              hide={false}
              sendText={t("sharing.part_competition")}
              showMobileClose
            >
              {competitions}
            </SendProjectsEntity>
            </ThemeProvider>
        </SendProjectModalWrapper>
    </ModalContainer>
}import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import { CompetitionSubtitle, ModalContainer} from './styles';
import {useTranslation} from "react-i18next";
import {
  CompetitionModalGS,
  SendProjectModalWrapper
} from "./employStyles";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import { API, APIResponse, Competition, CompetitionAPI, Endpoints, PageModel, Project } from "@brg/api";
import {useProfile} from "../../../core/hooks/auth/useProfile";
import {SortingTypeIndex} from "../../constants/sortingType";
import {LayoutConst, useModal} from "../../../core";
import {SendProjectsEntity} from "./SendProjectsEntity";
import { MagicBoxRow } from "shared/components/MagicBoxRow";
import { RingPositions } from "shared/constants/ringPositionType";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompetitionProjects, getListProps } from "shared/actions/competition";
import { RefreshListProps } from "_competition/pages/AllCompetitionsPage/AllCompetitionsPage";
import { STATUSES } from "_competition/const";
import { useCompetitionContexts } from "shared/hooks/useCompetitionContexts";
import { CompetitionsSelector } from "shared/reducers/Competitions";
import { CompetitionContainer } from "_competition/pages/AllCompetitionsPage/styled";
import { CompetitionCard } from "_competition/pages/AllCompetitionsPage/CompetitionCard";
import { AppTester } from "supporting";
import { ThemeProvider, useTheme } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";
import { SlideNavigation } from "shared/components/slideNavigation";
import { DropdownTabs } from "shared/pages/exploreHseContextsNew/components/DropdownTabs";
import { CreateLinkTo } from "shared/constants/linkTo";
import { DOCUMENT_VARIANT, getDocumentVariant } from "../competitionLegalsModal/types";

const PAGE_LIMIT = 100;

export const SendProjectToCompetition: FC<{project: Project, onCompleteSend?: () => void}> = ({project, onCompleteSend = () => {}}) => {
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s-1);
    const { t, i18n } = useTranslation();
    const theme1 = useTheme();
    const modal = useModal();
    const { theme } = createThemeByColor(theme1.competition.bg, theme1);
    const [time, setT] = useState(new Date().getTime());
    const profile = useProfile();
    const dispatch = useDispatch();
    const { data: competitionList } = useSelector(CompetitionsSelector);
    const [isSendingCompleted, setIsSendingCompleted] = useState(false);
    const [isTabChanged, setIsTabChanged] = useState(false);
    const [pageNumber] = useState(0);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const tabs = useCompetitionContexts();

    const navItems = useMemo(() => (
      {...tabs?.reduce((a, v) => ({ ...a, [v]: t(`tab_names.competition_tabs.${v}`).toLowerCase()}), {})}
    ), [tabs, t])

    const initialTab = useMemo(() => (
      Object.keys(navItems)?.find((item, idx) => idx === 0) ), [navItems])

    const [currentTab, setCurrentTab] = useState<string | undefined>(undefined);
    const [sorting, setSorting] = useState<any>(STATUSES.Open);

    const activeCurrentTab = currentTab ?? initialTab;

    const isAcademy = AppTester.isAcademy();

    const activeTab = useMemo(() => activeCurrentTab, [activeCurrentTab])

    const filterCurrentCompetitions = useCallback((item: APIResponse<PageModel<Competition<"Local">>>) => {
        return [STATUSES.Open].includes(item?.status)
      }, [])

    const fetchList = (props: RefreshListProps) => {
        const { pageNumber, i18n, selectedStatus, dispatch, contexts } = props
        const fetchListProps: getListProps = { initTags: true, limit: PAGE_LIMIT, page: pageNumber, i18n, contexts, initWinner: true, isBriefCompetition: false }
        if (selectedStatus?.identifier !== undefined && selectedStatus?.identifier !== STATUSES.Summarizing) {
          fetchListProps.competitionStatus = [selectedStatus?.identifier]
        }
        dispatch(fetchCompetitionProjects(fetchListProps))
      }

    const fetchProjects = (tab: string) => {
        fetchList({pageNumber, i18n, dispatch, selectedStatus: undefined, contexts: [tab] });
    }

    const onTabChange = useCallback((tab: string) => {
      setCurrentTab(tab);
    }, [])

    const onSelect = useCallback((id: string) => {
        const idx = selectedIds?.findIndex((i) => i === id);
        if (idx !== -1) {
            setSelectedIds(selectedIds?.filter((i) => i !== id));
        } else {
            setSelectedIds([...selectedIds, id])
        }
        setT(Date.now()) 
    }, [selectedIds])

    const isSelected = useCallback((id: string) => selectedIds?.includes(id) , [selectedIds])
//@ts-ignore
    const isPart = useCallback((id: string) => project?.competitionId?.includes(id) || project?.pendingCompetitionIds?.includes(id), [project])

      const filteredCompetitionList = useMemo(() => {
        const filteredCompetitionList = competitionList?.length ? competitionList?.filter((competition: any) => {
          return ![STATUSES.Deleted, STATUSES.Draft].includes(competition.status) && (competition.visibility || competition.visibility === null || competition.visibility === undefined)
        }).filter((i) => filterCurrentCompetitions(i)) : []
    
        if (!filteredCompetitionList?.length) {
          if (activeCurrentTab === "competitions" && isTabChanged) {
            setIsTabChanged(false)
          }
          return []
        }
    
        return filteredCompetitionList
      }, [competitionList, sorting, isMobile, activeCurrentTab, time])

      const getGroupedCompetitions = (competitions: any[]): {isNewType: boolean, items: Competition<'Local'>[]}[] => {
        const result: {isNewType: boolean, items: Competition<'Local'>[]}[] = [];
        var currentGroup: Competition<'Local'>[] = [];
        var isNewType = !!competitions?.[0]?.isNewType;
        competitions.map((x: any) => {
          if (isNewType === x.isNewType) {
            currentGroup.push(x);
          }
          else {
            if (currentGroup.length !== 0) {
              result.push({
                isNewType,
                items: currentGroup
              });
            }
            currentGroup = [];
            currentGroup.push(x);
            isNewType = !isNewType;
          }
        });
    
        if (currentGroup.length !== 0) {
          result.push({
            isNewType,
            items: currentGroup
          });
          currentGroup = [];
        }
        return result
      };

      const competitions = useMemo(() => {
          return (
            getGroupedCompetitions(filteredCompetitionList)
            .map(x => {
              if (x.isNewType) {
                return (
                  <CompetitionContainer>
                    {x.items
                    .map((item, idx, arr) => {
                      const projectsOrder = [
                      'e1f20bda47bb40dd94f4360873cc0871', 
                      'fba8ef7dd7a643269997a9ecbad02ed0',
                      '0dc30b10959847a99aa575d98e6e28b0', 
                      '74d96d672033451a9028a4f1ff12e0b6', 
                      '1c891534c43b4a2abf8868ac03250381',
                      '4585d3c8c68648efa18e4b9d511834d6',
                      'b401549c47f640b29855f2e4068da7c1'
                      ];
    
                      if (isAcademy && activeCurrentTab === 'genius') {
                        return arr?.find((i) => i?.competitionId === projectsOrder[idx])
                      }
                      return item
                    })
                    .map((competitionProps, index, srcArray) => {
                        const selected = isSelected(competitionProps?.competitionId ?? '');
                        const already = isPart(competitionProps?.competitionId ?? '');
                      return (
                        <CompetitionCard
                          key={competitionProps?.competitionId}
                          isNewType={x?.isNewType}
                          competitionProps={competitionProps}
                          isModalCard
                          selectRingPosition={RingPositions.left}
                          onSelect={onSelect}
                          isSelected={selected}
                          isAlready={already}
                        />
                      )
                    }
                    )}
                  </CompetitionContainer>
                );
              }
            })
          )
      }, [activeCurrentTab, filteredCompetitionList, isAcademy, onSelect, isSelected, isPart]);

    useEffect(() => {
        fetchProjects(activeTab)
    }, [time, activeTab])
    
    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
      setSorting(s);
      setT(Date.now());
    }, []);

    const onMobileSortingClick = useCallback(() => {
      setSorting((prev: any) => prev === 1 ? 2 : 1);
    }, []);


    const onSendSimpleNomination = useCallback(async (arr: string[]) => {
      await Promise.all(arr.map(value => {      
        CompetitionAPI.Get({ idCompetition: value, initWinner: true })
        .then((v) => v.json())
        .then((v) => API.toLang<Competition<'Local'>>(v, i18n.language))
        .then((v) => {
          if (v) {
            API.request()
            .endpoint(Endpoints.competitions)
            .url('/api/Competition/Apply')
            .post()
            .addQuery('NominationID', v?.nominationsID?.length ? v.nominationsID[0] : '')
            .addQuery('ProjectID', project?.projectId)
            .send()
          }
        });
      })
    );

    modal.show('competition-sent', {
      competitionId: '',
      someNominations: arr?.length > 1,
      isShareModal: true,
      onClick: () => {
        window.open(CreateLinkTo.explore(), '_SELF')
      },
    });
  }, [i18n,modal, project]) 

    const onSend = useCallback(async () => {

        const res = window.confirm(t('competition.confirm_msg.send'));
        if (!res) return;

          try {
            await CompetitionAPI.GetList({ competitionIds: selectedIds })
            .then((v) => v.json())
            .then((r) => {
              const data = r?.data?.map((i) => API.toLang<Competition<'Local'>>(i, i18n.language));

              if (data?.length) {
                const shouldViewLegalsModal = data?.some((c) => [DOCUMENT_VARIANT.full, DOCUMENT_VARIANT.short]?.includes(getDocumentVariant(c)));

                if (shouldViewLegalsModal) {
                  const nominationsIds = data?.map((c) => c?.nominationsID?.[0]);
                  const hasDocuments = data?.some((c) => [DOCUMENT_VARIANT.full]?.includes(getDocumentVariant(c)));
                  modal.show('competition-form', {
                    projects: [project?.projectId],
                    nominationIds: nominationsIds,
                    // @ts-ignore
                    competitionId: competitions?.competitionId,
                    hasDocuments,
                    callback: () => {
                      modal.hide();

                      setTimeout(() => {
                        modal.show('competition-sent', {
                          competitionId: '',
                          someNominations: selectedIds?.length > 1,
                          isShareModal: true,
                          onClick: () => {
                            window.open(CreateLinkTo.explore(), '_SELF')
                          },
                      });
                      })
                    },
                  })
                } 
                else onSendSimpleNomination(selectedIds)
              }
            })

            setSelectedIds([]);
            setT(Date.now());
          
          } catch (e) {
            return new Error(String(e))
          }
    }, [selectedIds, project, i18n.language, t, modal, onSendSimpleNomination])

    const title = useMemo(() => <CompetitionSubtitle>{t('sharing.part_subtitle_text')}</CompetitionSubtitle>, [t])

    const tabsComponent = useMemo(() => {
      return (
        <FlexBox offsetTopMobile={isS ? 8 : 0}>
          {!isMobile ? (
            <SlideNavigation
              activeIndexKey={activeTab}
              onChange={onTabChange}
              items={navItems}
              isDropdown
              autoWidth
              isLoading={false}
              whiteTheme={false}
              isCompetition={true}
            /> 
          ) : (
           <>
              <DropdownTabs
                customTitleTheme={theme as any}
                whiteTheme={false}
                activeTabKey={activeTab}
                isShort={true}
                items={navItems}
                onChange={onTabChange}
              />
           </>
          )}
        </FlexBox>
      )
    }, [activeTab, navItems, theme, isMobile, onTabChange ])

    if (!profile) {
        return null;
    }


    return <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
        <SendProjectModalWrapper width={'100%'} directionMobile='column' direction='column' justify={'flex-start'} align={"center"} alignMobile="flex-start" style={{ position: 'relative'}}>
            <ThemeProvider theme={theme as any}>
              <CompetitionModalGS />
            <SendProjectsEntity
              isCompetitionModal 
              noProjectCheckbox={title}
              tabs={tabsComponent} 
              noProjectVisible
              hideFilter
              count={selectedIds?.length || 0}
              isDisabledSendButton={!selectedIds?.length} 
              onMobileSortingClick={onMobileSortingClick} 
              onSortingChange={onSortingChange} 
              sorting={sorting} 
              onSend={onSend} 
              isClosed={!(!isSendingCompleted)}
              hide={false}
              sendText={t("sharing.part_competition")}
              showMobileClose
            >
              {competitions}
            </SendProjectsEntity>
            </ThemeProvider>
        </SendProjectModalWrapper>
    </ModalContainer>
}